import { ComponentPropsWithoutRef } from 'react';
import Image, { ImageProps } from 'next/image';
import { Grid, Typography } from '@mui/material';

interface IStepByStepCardProps extends ComponentPropsWithoutRef<'button'> {
  title: string;
  subtitle?: string;
  imageProps: ImageProps;
}

export interface IModalStepByStepCard {
  closeModal: () => void;
  onSuccess: () => void;
  isOpen: boolean;
}

const StepByStepCard = ({
  imageProps,
  title,
  subtitle,
  disabled,
  ...rest
}: IStepByStepCardProps) => {
  return (
    <Grid
      component={'button'}
      container
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        textAlign: 'left',
        backgroundColor: disabled ? '#FAFAFA' : '#FFFFFF',
        borderRadius: '12px',
        padding: '16px',
        height: '121px',
        width: '100%',
        marginBottom: '16px',
        border: disabled ? '1px solid rgba(0, 0, 0, 0.05)' : 'none',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
        filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1))',
        '&:not(:disabeld):hover': {
          transition: 'all 200ms ease-in',
          filter: 'brightness(.96)',
        },
        '&:not(:disabeld):active': {
          boxShadow: 'inset 0px 0px 35px -15px rgba(0, 0, 0, .60)',
        },
      }}
      disabled={disabled}
      {...rest}
    >
      <Grid
        item
        xs={2}
        sx={{
          position: 'relative',
          '&:is(button:disabled &)::after': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundColor: '#B5B5B5',
            mixBlendMode: 'color',
            top: '0',
            left: '0',
          },
        }}
      >
        <Image alt="" {...imageProps} width="87px" height="58px" />
      </Grid>
      <Grid item xs={9} sx={{ pl: 1 }}>
        <Typography
          sx={{
            color: disabled ? 'rgba(0, 0, 0, 0.3)' : 'primary.main',
            whiteSpace: 'nowrap',
          }}
          variant="h6"
        >
          {title}
        </Typography>
        <Typography
          variant="caption"
          sx={{ color: disabled ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.5)' }}
          data-testid={title}
        >
          {subtitle || '-'}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default StepByStepCard;
